/**
 * ThirdNav: Toggle for third nav.
 */
(function($) {
  "use strict";

  $(window).ready(init);

  // Constants
  var CONTAINER_SEL = '.ThirdNav';
  var BTN_SEL = '.burger-menu';

  // Init
  function init() {
    var container = $(CONTAINER_SEL);
    if (container.length === 0) {
      return;
    }

    container.on("click", BTN_SEL, function(event) {
      var el = $(this).parent();
      el.attr(
        "aria-expanded",
        el.attr("aria-expanded") == "true" ? "false" : "true"
      );
    })
  }
})(jQuery);